<template>
  <router-link class="back-link" :to="to">
    <vb-icon :name="'chevron-left'" :size="14" :color="sass('info')" />
    <span>{{ text }}</span>
  </router-link>
</template>

<script>
export default {
  name: 'back-link',

  props: {
    to: {
      type: Object,
      required: true,
    },
    text: {
      type: String,
      default: 'indietro',
    },
  },
}
</script>

<style lang="scss" scoped>

  .back-link {
    display: inline-flex;
    align-items: center;
    margin-bottom: $grid-gutter-width/2;
    color: $info;

    .vb-icon {
      margin-right: $grid-gutter-width/6;
    }
  }

</style>
